module.exports = __webpack_public_path__ + "f65dd73e5340867ec1dab7492dcc80aa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/laptop.png
// module id = 2671
// module chunks = 0